/**
 * Brochure designs — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_office_formats`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const brochureDesignsPack: ToilePack = {
    slug: 'brochure-designs',
    category: 'office',
    name: 'Brochure designs',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'trifold', label: 'Trifold', subject: 'a trifold brochure layout with three panels'},
        {key: 'bifold', label: 'Bifold', subject: 'a bifold brochure layout'},
        {key: 'flyer', label: 'Flyer', subject: 'a single page brochure layout'},
    ],
    styles: [
        {key: 'corporate', label: 'Corporate', style: 'corporate layout with a cover panel, photo placeholders as grey boxes and a coloured inside panel', palette: 'blue and white with grey boxes', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'bright', label: 'Bright', style: 'bright playful layout with rounded shapes, large colour blocks and icon circles', palette: 'orange, teal and white', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'elegant', label: 'Elegant', style: 'elegant minimal layout with generous white space, thin gold lines and a serif title', palette: 'charcoal and gold on white', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
    ],
    directions: ['green theme', 'dark theme', 'with map'],
    directionHint: 'try: green theme',
    seo: {
        title: 'Brochure design: trifold, bifold, single page',
        metaDescription: 'Nine printable brochure designs: a trifold, a bifold and a single-page brochure, each in corporate, bright or elegant style.',
        h1: 'Brochure design: trifold, bifold, single page',
        tagline: 'Three brochure layouts, each in three styles, with a cover panel and grey boxes for photos.',
        intro: 'A brochure design is the folded or single-sheet layout used to show a business or an offer. These nine show a trifold with three panels, a bifold, and a single-page brochure. Only the Our Services and Contact headings are lettered; the text is grey lines. Type a twist, such as green theme, and it is a request.',
        useCases: [
            'a service brochure for a small business',
            'an offer leaflet to hand out',
            'a community or club leaflet',
            "a leaflet for a shop's counter",
        ],
        faq: [
            {q: 'What is the difference between a trifold and a bifold?', a: 'A trifold folds into three panels and a bifold folds into two. The single-page layout is one sheet with no fold.'},
            {q: 'Is the layout ready to print?', a: 'It is a flat, print-ready design with an even margin. Check the fold lines with your printer.'},
            {q: 'What do the grey boxes mean?', a: 'They mark where photos go. Put your own pictures in them.'},
            {q: 'Can I change the colour?', a: 'Type it as a twist, such as green theme. It is a request for that colour, not a promised result.'},
        ],
    },
}
